import type { WatchQueryFetchPolicy } from "@apollo/client";
import {
  GetPendingCancellationPolicyListItemsQueryVariables,
  useGetPendingCancellationPolicyListItemsQuery as useGetPendingCancellationPolicyListItemsBaseQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting Pending Cancellation policy list items based on the user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - policies list, total count, error and loading state.
 */
export function useGetPendingCancellationPolicyListItemsQuery(
  variables: GetPendingCancellationPolicyListItemsQueryVariables
) {
  const queryOptions: {
    fetchPolicy: WatchQueryFetchPolicy;
    variables: GetPendingCancellationPolicyListItemsQueryVariables;
  } = {
    fetchPolicy: "cache-and-network",
    variables,
  };

  const { data, error, loading, previousData } =
    useGetPendingCancellationPolicyListItemsBaseQuery(queryOptions);

  return {
    error,
    loading: loading && !data,
    policies: data?.getPendingCancellationPolicyListItems.items ?? [],
    totalCount:
      data?.getPendingCancellationPolicyListItems.pagination.total ??
      previousData?.getPendingCancellationPolicyListItems.pagination.total ??
      0,
  };
}
